import { positionStackInstance } from "../config/axios";

export const getBasketTotal = (basket) =>
  basket?.reduce((amount, item) => item.price + amount, 0);

export const getUserLocation = (lat, lng) => {
  return positionStackInstance(
    process.env.REACT_APP_POSITION_STACK_API_KEY,
    lat,
    lng
  ).get();
};
